import * as React from 'react'

const SvgTextAlignLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3.75h8.75V5H7.5V3.75zm0 3.75h6.25v1.25H7.5V7.5zm0 3.75h8.75v1.25H7.5v-1.25zm0 3.75h6.25v1.25H7.5V15zM3.75 2.5H5v15H3.75v-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextAlignLeftIcon
